import { useChatStore } from '@stores/chat';
import { useCodePreviewStore } from '@stores/codePreview';
import { useCreditNoticeStore } from '@stores/creditNotice';
import { useFirstGenerationJourneyStore } from '@stores/firstGenerationJourney';
import { useMediaReadyStore } from '@stores/mediaReady';
import { usePreviewStore } from '@stores/preview';
import { useProjectStore } from '@stores/project';
import { usePublishStore } from '@stores/publish';
import { useAutoInputStore } from '@/stores/autoInput';
import { useModalVersionSwitch } from '@/stores/modalVersionSwitch';
import { useSiteAuditStore } from '@/stores/siteAudit';
import { useToolApprovalStore } from '@/stores/toolApproval';
import { useTourStore } from '@/stores/tour';

/**
 * 重置所有项目相关的状态
 * 使用场景：
 * 1. 项目切换：从项目 A 切换到项目 B 时清理旧项目状态
 * 2. 返回工作台：离开项目详情页返回工作台时清理项目状态
 * 3. 避免状态污染和内存泄漏
 */
export function resetAllProjectStores() {
  useAutoInputStore.getState().reset();
  useProjectStore.getState().reset();
  usePreviewStore.getState().reset();
  useChatStore.getState().resetChat();
  useCreditNoticeStore.getState().reset();
  useToolApprovalStore.getState().deactivate();
  usePublishStore.getState().reset();
  useMediaReadyStore.getState().reset();
  useModalVersionSwitch.getState().reset();
  useSiteAuditStore.getState().reset();
  useTourStore.getState().reset();
  useCodePreviewStore.getState().reset();
  useFirstGenerationJourneyStore.getState().reset();
}
